<template>
  <div class="startbucks-custom-referral-info">
    <div class="referral-info-title">{{ $t(`${i18nKeyPrefix}.title`) }}</div>
    <div class="referral-info">
      <div class="list-head" @click="handleExpandList">
        <span>{{ $t(`${i18nKeyPrefix}.listHead`) }}</span>
        <div class="expand-list-btn">
          <i :class="isExpand ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>
        </div>
      </div>
      <div v-show="isExpand" v-infinite-scroll="infiniteLoad" class="info-list" :infinite-scroll-disabled="disableInfinite">
        <div class="info-list-item item-head">
          <div class="applicant-name">{{ $t(`${i18nKeyPrefix}.listColumnName.applicantName`) }}</div>
          <div class="job-name">{{ $t(`${i18nKeyPrefix}.listColumnName.jobName`) }}</div>
          <div class="step-name">{{ $t(`${i18nKeyPrefix}.listColumnName.stepName`) }}</div>
          <div class="date">{{ $t(`${i18nKeyPrefix}.listColumnName.date`) }}</div>
        </div>
        <div
          v-for="(item, index) in infoList"
          class="info-list-item"
          :key="index"
        >
          <div class="applicant-name">{{ item.applicantName }}</div>
          <div class="job-name">{{ item.jobName }}</div>
          <div class="step-name">{{ $t(item.stepNameI18nKey) }}</div>
          <div class="date">{{ item.date || $t(item.dateI18nKey) }}</div>
        </div>
      </div>
    </div>
    <div class="referral-info-footer">
      <el-button class="view-policy-btn" @click="handleShowPolicy">{{ policyInfo.btnLabel }}</el-button>
    </div>
    <el-dialog class="policy-dialog" :visible.sync="showPolicy">
      <div class="company-logo">
        <img :src="companyLogoPath"/>
      </div>
      <div class="dialog-title">{{ policyInfo.dialogTitle }}</div>
      <div class="policy-img">
        <img :src="policyInfo.dialogImg"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'
import { deviceType } from '@/utils/common'

export default {
  props: {
    employeeInfo: {
      required: true
    }
  },
  data () {
    return {
      i18nKeyPrefix: 'personal.referrals.rewards.custom.starbucks',
      infoList: [],
      pageInfo: {
        total: 2,
        pageSize: 20,
        page: 1
      },
      isExpand: true,
      disableInfinite: false,
      showPolicy: false,
      policyInfo: {
        btnLabel: '',
        dialogTitle: '',
        dialogImg: ''
      }
    }
  },
  computed: {
    isPc () {
      return deviceType.isPc
    },
    isEn () {
      return this.$i18n.local === 'en'
    },
    companyLogoPath () {
      return this.$DjangoBaseUrl(this.employeeInfo.company.logo_path)
    }
  },
  created () {
    this.initData()
  },
  methods: {
    ...mapActions('company', ['getCustomRewardsRuleInfo']),
    ...mapActions('personal', ['getMyReferralHistory']),
    async initData () {
      this.$eventBus.$emit('showLoading', true)
      try {
        const companyId = this.employeeInfo.company.id
        const resp = await this.getCustomRewardsRuleInfo(companyId)
        if (resp) {
          const vm = this
          this.policyInfo = {
            info: resp,
            get btnLabel () {
              const btnLabel = this.info.btn_label
              return vm.isEn ? btnLabel.en : btnLabel.cn
            },
            get dialogTitle () {
              const title = this.info.dialog_title
              return vm.isEn ? title.en : title.cn
            },
            get dialogImg () {
              const img = this.info.dialog_img
              return vm.$DjangoBaseUrl(vm.isPc ? img.pc : img.mobile)
            }
          }
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async infiniteLoad () {
      this.$eventBus.$emit('showLoading', true)
      this.disableInfinite = true
      try {
        const params = {
          page: this.pageInfo.page,
          page_size: this.pageInfo.pageSize
        }
        const resp = await this.getMyReferralHistory(params)
        if (resp) {
          this.pageInfo.total = resp.total_pages
          this.pageInfo.page += 1
          if (this.pageInfo.total > 0 && this.pageInfo.page < this.pageInfo.total) {
            this.disableInfinite = false
          }
          const vm = this
          const now = moment()
          const yesterday = moment().subtract(1, 'days')
          this.infoList = _.map(resp.results, (item) => {
            const infoItem = {
              data: item,
              get jobName () {
                const jobData = this.data.job
                return vm.isEn ? jobData.name : jobData.cn_name
              },
              applicantName: item.applicant.name,
              stepNameI18nKey: `${this.i18nKeyPrefix}.stepName.${item.step}`
            }
            const grantDate = moment(item.grant_date)
            if (grantDate.isSame(now, 'day')) {
              infoItem.date = grantDate.format('HH:mm')
            } else if (grantDate.isSame(yesterday, 'day')) {
              infoItem.dateI18nKey = 'common.date.yesterday'
            } else {
              infoItem.date = grantDate.format('YYYY/MM/DD')
            }
            return infoItem
          })
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handleExpandList () {
      if (!this.isPc) {
        return
      }
      this.isExpand = !this.isExpand
    },
    handleShowPolicy () {
      this.showPolicy = true
    }
  }
}
</script>

<style lang="scss" scoped>
.startbucks-custom-referral-info {
  padding-left: 30px;

  .referral-info-title {
    text-align: center;
    font-weight: bold;
    font-size: 28px;
  }

  .referral-info {
    margin-top: 15px;

    .list-head {
      padding-bottom: 3px;
      font-size: 18px;
      color: #808080;
      border-bottom: 2px solid #808080;
      cursor: pointer;
      position: relative;

      .expand-list-btn {
        font-size: 12px;
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }

    .info-list {
      .info-list-item {
        display: flex;
        padding: 20px 10px;
        border-bottom: 1px solid #ccc;

        > * {
          margin: 0 10px;
          text-align: center;
          overflow: hidden;
          word-break: keep-all;
          white-space: nowrap;
          text-overflow: ellipsis;

          &:first-child {
            margin-left: 0;
          }

          &:last-child {
            margin-right: 0;
          }
        }

        .applicant-name {
          width: 70px;
        }

        .job-name {
          flex: 1;
        }

        .step-name {
          width: 90px;
          color: var(--custom-color);
        }

        .date {
          width: 120px;
        }

        &.item-head {
          padding-bottom: 10px;
          font-weight: bold;
          border-bottom: 0;

          .step-name {
            color: inherit;
          }
        }
      }
    }
  }

  .referral-info-footer {
    margin: 50px 0;
    text-align: center;

    .view-policy-btn {
      width: 340px;
      padding: 6px 20px;
      border: 0;
      border-radius: 0;
      background: var(--custom-color);
      color: #fff;
      font-size: 18px;
    }
  }

  .policy-dialog {
    ::v-deep {
      .el-dialog  {
        width: 550px;
      }

      .el-dialog__header {
        padding: 0;
      }

      .el-dialog__body {
        padding-top: 15px;
        padding-bottom: 15px;
      }
    }

    .company-logo {
      img {
        width: 50px;
        height: 50px;
      }
    }

    .dialog-title {
      margin-bottom: 20px;
      color: var(--custom-color);
      font-size: 18px;
      font-weight: bold;
      text-align: center;
    }

    .policy-img {
      text-align: center;
    }
  }
}
.page-moblie {
  .startbucks-custom-referral-info {
    padding: 0;
    border-radius: 5px;
    background: #fff;

    .referral-info-title {
      padding: 20px 0 40px;
      font-weight: initial;
    }

    .referral-info {

      .list-head {
        padding-left: 10px;
        border-bottom: 1px solid #ccc;

        .expand-list-btn {
          display: none;
        }
      }

      .info-list {
        padding: 0 10px;

        .info-list-item {
          padding: 10px;
          flex-direction: column;

          > * {
            width: 100%;
            font-size: 14px;
            margin: 0;
            padding-left: 0px;
            text-align: left;
          }

          .step-name {
            font-weight: bold;
          }

          &.item-head {
            display: none;
          }
        }
      }
    }

    .referral-info-footer {
      display: flex;
      margin: 0;

      .view-policy-btn {
        width: 80%;
        margin: 20px auto;
        border-radius: 15px;
      }
    }

    .policy-dialog {
      ::v-deep {
        .el-dialog  {
          width: 80%;
        }

        .el-dialog__body {
          padding: 5px 15px 15px;
        }
      }

      .dialog-title {
        font-size: 15px;
      }

      .policy-img {
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
